import * as React from "react";
import * as classNames from "classnames";
import TextArea from "./TextArea";

export interface TextFormGroupProps {}

class TextAreaFormGroup extends React.PureComponent<any, any> {
  render() {
    return (
      <div
        className={classNames(
          "mb-0 form-group",
          {
            "has-success":
              this.props.validate && this.props.valid && this.props.touched
          },
          {
            "has-danger":
              this.props.validate && !this.props.valid && this.props.touched
          }
        )}
      >
        <TextArea
          className={classNames(
            "form-control",
            { "form-control-success": this.props.valid && this.props.touched },
            { "form-control-danger": !this.props.valid && this.props.touched }
          )}
          name={this.props.name}
          id={this.props.id}
          onBlur={this.props.onBlur}
          onChange={this.props.onChange}
          onFocus={this.props.onFocus}
          onKeyPress={this.props.onKeyPress}
          placeholder={this.props.placeholder}
          value={this.props.value}
          disabled={this.props.disabled}
          maxLength={this.props.maxLength}
          type={this.props.type}
          autoComplete={this.props.autoComplete}
          rows={this.props.rows}
        />
        {this.props.children}
      </div>
    );
  }
}

export default TextAreaFormGroup;



// WEBPACK FOOTER //
// ./src/components/Controls/TextAreaFormGroup.tsx